import React from "react";
import map from "lodash/map";
import { useTranslation } from "react-i18next";
import moment from "moment";
import MetricsFoot from "../../../athlete-portal/metrics/MetricsFoot";
import MetricsBackButton from "../../../athlete-portal/metrics/metrics-back-button";
import set from "@rill/set";
import { useRillContext } from "../../../../rill/RillReact/share/base";

function View(props) {
  const { locals } = useRillContext();
  const { t } = useTranslation("dashboard");

  const { listCustomMetrics } = locals;
  return (
    <div className="Main Metrics">
      <MetricsBackButton url={`/dashboard/metrics`} />
      <div className="CMR-Head">
        <h1 className="custom-report alt">{t("dashboard:customMetricsList.title")}</h1>
        <span className="description">
          {t("dashboard:customMetricsList.description")}
        </span>
        <a className="add-new" href={`/dashboard/metrics/custom/edit`}>
          {t("dashboard:customMetricsList.createReport")}
        </a>
      </div>

      <div className="CMR-Archive">
        {map(listCustomMetrics, (customMetric, i) => {
          return (
            <div className="item" key={customMetric._id}>
              <div className="name">{customMetric.name}</div>
              <div className="date">
                {moment.utc(customMetric.date).format("MMM DD, YYYY")}
              </div>
              <a
                className="link"
                href={`/dashboard/metrics/custom/view/${customMetric._id}`}
              />
            </div>
          );
        })}
      </div>
      <MetricsFoot shareHref="/actions/refresh?modal[type]=share" />
    </div>
  );
}

const List = (app) => {
  app.get(
    "/list",
    set("heading", "Custom Metrics Reports"),
    async ({ res, load }) => {
      await load("listCustomMetrics");
      res.body = <View />;
    }
  );
};

export default List;
